// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2WVkt","boxTitle":"Qualiphy_boxTitle__1n-Ry","box":"Qualiphy_box__3YEC9","toggleWrap":"Qualiphy_toggleWrap__qrsoP"};